import { connect } from 'react-redux';

import { goToNextStep, goToErrorPage } from '../actions/GenericActions';
import { getFullContacts } from '../actions/contacts.actions';
import ContactView from '../components/Steps/Contact/ContactView';

const mapDispatchToProps = dispatch => ({
  getFullContacts: () => dispatch(getFullContacts()),
  goToErrorPage: () => dispatch(goToErrorPage()),
  goToNextStep: step => dispatch(goToNextStep(step)),
});

const mapStateToProps = state => ({
  contacts: state.contacts,
  identitiesId: state.identification.identitiesId,
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactView);
